import React from 'react';
import { makeStyles, useMediaQuery, useTheme } from '@material-ui/core';
import Typography from '../overrides/Typography';
import { ERROR_PAGE_TYPES } from '../../utils/constants/ErrorPageTypes';

const useStyles = makeStyles((theme) => ({
  img: {
    display: 'block',
    margin: theme.spacing(0, 'auto'),
    marginBottom: theme.spacing(4),
  },
  title: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(0.5),
    textAlign: 'center',
  },
  errorMessage: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(3),
    textAlign: 'center',
  },
}));

const ErrorSnippet = ({ type = ERROR_PAGE_TYPES.GENERIC.value }) => {
  const classes = useStyles();
  const error = ERROR_PAGE_TYPES[type];
  const theme = useTheme();
  const isMobileDevice = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <img
        alt={error.iconAlt}
        aria-hidden
        className={classes.img}
        src={error.iconSrc}
      />
      {error.errorTitle != null && (
        <Typography
          component="h1"
          className={classes.title}
          variant={isMobileDevice ? 'large1Light' : 'large2Light'}>
          {error.errorTitle}
        </Typography>
      )}
      {error.errorMessage != null && (
        <Typography
          className={classes.errorMessage}
          variant={error.errorMessageVariant}>
          {error.errorMessage}
        </Typography>
      )}
    </>
  );
};

export default ErrorSnippet;
